const SendSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.8442 3.06705C12.9669 3.15629 13.0172 3.27527 12.9948 3.42399L11.5664 11.9905C11.5478 12.0984 11.4883 12.182 11.3878 12.2415C11.3358 12.2712 11.2781 12.2861 11.2149 12.2861C11.174 12.2861 11.1293 12.2768 11.081 12.2582L8.14037 11.0591L6.47757 12.8829C6.41062 12.961 6.3232 13 6.21532 13C6.16324 13 6.12046 12.9926 6.08698 12.9777C6.01631 12.9517 5.96051 12.908 5.91959 12.8466C5.87867 12.7853 5.85821 12.7174 5.85821 12.6431V10.1222L3.22452 9.04578C3.08688 8.99373 3.01248 8.89148 3.00132 8.73904C2.99016 8.59403 3.04968 8.48435 3.17988 8.40999L12.4648 3.0559C12.595 2.97782 12.7214 2.98154 12.8442 3.06705ZM10.9359 11.4272L12.169 4.04864L4.16751 8.66096L6.04234 9.42503L10.8578 5.86122L8.19059 10.3062L10.9359 11.4272Z"
        fill="white"
      />
    </svg>
  );
};

export default SendSvg;
